import { Injectable } from '@angular/core';

// INTERFACES

export interface Environment {
  /** The base URL. */
  url :string;
  /** The v1 API path, **without** the base URL. */
  urlV1 :string;
  /** The v2 API path, **without** the base URL. */
  urlV2 :string;
}

// THE SERVICE

@Injectable({
  providedIn: 'root',
})
export class EnvironmentUtilService {
  constructor() {}

  setEnvironment() :void {}

  getEnvironment() :Environment {
    const environment = JSON.parse(
      localStorage.getItem(`environment_${location.origin}`) || '{}',
    );
    const { url, urlV2, accessTokenKey } = environment;

    return {
      url: url.replace('/api/admin', ''),
      urlV1: '/api/admin',
      urlV2: '/v2/api/admin',
    };
  }
}
